import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=eb1e219c&scoped=true&"
import script from "./Ventas.vue?vue&type=script&lang=js&"
export * from "./Ventas.vue?vue&type=script&lang=js&"
import style0 from "./Ventas.scss?vue&type=style&index=0&id=eb1e219c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1e219c",
  null
  
)

export default component.exports